import Vue from 'vue'
import VueCookies from 'vue-cookies'
import busstop from './busstop'
import serviceArea from './serviceArea'
import reservation from './reservation'
import user from './user'

Vue.use(VueCookies)

const api = {
  ...busstop,
  ...serviceArea,
  ...reservation,
  ...user
}

export default api
